import React from 'react';
import { connect } from 'react-redux';
import { usePushNotifications } from '../../hooks/usePushNotifications';
import { 
  Card, 
  CardContent, 
  Typography, 
  Switch, 
  Box, 
  CircularProgress,
  Paper
} from '@material-ui/core';
import { 
  Notifications as BellIcon, 
  NotificationsOff as BellOffIcon,
  Warning as AlertCircleIcon
} from '@material-ui/icons';
import './NotificationSettings.css';

const NotificationSettings = ({ roleCode }) => {
  const {
    subscription,
    permission,
    isLoading,
    error,
    subscribe,
    unsubscribe,
    isSupported
  } = usePushNotifications();

  // IMPORTANT: Only show notification settings for agents
  if (!roleCode || roleCode !== 'agent') {
    return null; // Don't render anything for non-agents
  }

  if (!isSupported) {
    return (
      <Card className="notification-settings">
        <CardContent>
          <Paper className="notification-alert warning">
            <Box display="flex" alignItems="center" p={2}>
              <AlertCircleIcon className="alert-icon" />
              <Typography variant="body1" style={{ marginLeft: 8 }}>
                Push notifications are not supported in your browser.
              </Typography>
            </Box>
          </Paper>
        </CardContent>
      </Card>
    );
  }

  const handleToggle = async () => {
    if (subscription) {
      await unsubscribe();
    } else {
      await subscribe();
    }
  };

  return (
    <Card className="notification-settings">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Push Notifications
        </Typography>
        
        {error && (
          <Paper className="notification-alert error">
            <Box display="flex" alignItems="center" p={2}>
              <AlertCircleIcon className="alert-icon" />
              <Typography variant="body1" style={{ marginLeft: 8 }}>
                {error}
              </Typography>
            </Box>
          </Paper>
        )}

        {permission === 'denied' && (
          <Paper className="notification-alert warning">
            <Box display="flex" alignItems="center" p={2}>
              <AlertCircleIcon className="alert-icon" />
              <Typography variant="body1" style={{ marginLeft: 8 }}>
                You have blocked notifications. Please enable them in your browser settings to receive push notifications.
              </Typography>
            </Box>
          </Paper>
        )}

        <Box display="flex" alignItems="center" justifyContent="space-between" className="notification-toggle">
          <Box display="flex" alignItems="center">
            {subscription ? (
              <>
                <BellIcon className="notification-icon active" />
                <Box ml={2}>
                  <Typography variant="subtitle1">Notifications Enabled</Typography>
                  <Typography variant="body2" color="textSecondary">
                    You'll receive notifications when you get new messages
                  </Typography>
                </Box>
              </>
            ) : (
              <>
                <BellOffIcon className="notification-icon" />
                <Box ml={2}>
                  <Typography variant="subtitle1">Notifications Disabled</Typography>
                  <Typography variant="body2" color="textSecondary">
                    Enable to receive message notifications
                  </Typography>
                </Box>
              </>
            )}
          </Box>

          {isLoading ? (
            <CircularProgress size={24} />
          ) : (
            <Switch
              checked={!!subscription}
              onChange={handleToggle}
              disabled={permission === 'denied'}
              color="primary"
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  roleCode: state.user.info.roleCode
});

export default connect(mapStateToProps)(NotificationSettings);